import { AIInsightsCard } from '@components/shared/AIInsightsCard';
import { Highlights } from '@features/campaigns/components/Highlights';
import { useRslAIInsights } from '../../../hooks/useRslAIInsights';
import { RslReport } from '../../../api/schema';
import { ReactNode } from 'react';
import { FormatValue, visitHighlightsText } from '@features/campaigns';

const formatValue: FormatValue<ReactNode> = (value, key) => (
  <b key={key}>{value}</b>
);

type AIInsightsProps = {
  report: Pick<
    RslReport,
    | 'uniqueUsers'
    | 'totalProjectedVisits'
    | 'incrementalVisitLift'
    | 'projectedIncrementalVisits'
    | 'visitAIInsights'
    | 'aiInsights'
  >;
  campaignName: string;
};

export const AIInsights = (props: AIInsightsProps) => {
  const { visitInsights: summaryAiInsights } = useRslAIInsights(
    props.report,
    'summary',
    null
  );

  return (
    <AIInsightsCard
      testId="rsl-visit-metrics-ai-insights"
      title="Summary"
      aiInsights={summaryAiInsights ?? undefined}
      highlights={
        <Highlights sx={{ height: '100%' }}>
          {visitHighlightsText({
            metrics: {
              uniqueUsers: props.report.uniqueUsers ?? 0,
              projectedVisits: props.report.totalProjectedVisits ?? 0,
              incrementalLift: props.report.incrementalVisitLift ?? 0,
              incrementalVisits: props.report.projectedIncrementalVisits ?? 0,
            },
            campaignName: props.campaignName,
            formatValues: {
              uniqueUsers: formatValue,
              projectedVisits: formatValue,
              incrementalLift: formatValue,
              incrementalVisits: formatValue,
            },
          })}
        </Highlights>
      }
    />
  );
};
